import packageInfo from '../../package.json';
import { normalizeCargoCountryCode } from './cargoNameValidation';

/** @returns {{frontend_version: string, frontend_build: string, frontend_bundle: string|null}} */
export function getFrontendBuildInfo() {
    const script = document.querySelector('script[src*="/static/js/main."]');
    return {
        frontend_version: packageInfo.version,
        frontend_build: process.env.REACT_APP_BUILD_ID || packageInfo.version,
        frontend_bundle: script?.getAttribute('src')?.split('/').pop()?.split('?')[0] || null,
    };
}

/** @param {{event: string, data: object, message: string|null, platform: string, userId: string|number|null, step?: number, nextStep?: number}} details */
export function reportCargoNameValidation({event, data, message, platform, userId, step, nextStep}) {
    try {
        void window.fetch(`${process.env.REACT_APP_API_URL}/api/debug/log`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                ...getFrontendBuildInfo(),
                event, platform, userId,
                contract_number: data.contract_number,
                route: window.location.pathname,
                step, next_step: nextStep,
                city_from: data.cityFrom, city_to: data.cityTo,
                country_from: data.cityFromCountryCode ?? null,
                country_to: data.cityToCountryCode ?? null,
                normalized_country_from: normalizeCargoCountryCode(data.cityFromCountryCode),
                normalized_country_to: normalizeCargoCountryCode(data.cityToCountryCode),
                cargo_names: data.places?.map(place => place.goods?.map(good => good.name)),
                validation_message: message,
            }),
        }).catch(() => {});
    } catch {
        // Diagnostics must never prevent correcting or submitting the form.
    }
}
